import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";


function FitrosDobleCheckComponent({
    title, fechaInicio, handleFechaInicio, fechaFin, handleFechaFin,
    clienteSelected, loadingCargarCliente, dataClientes, handleNameClienteSearch, handleClienteSelected,
}) {

    const inputBaseClass = "w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200";

    const formatDateInputValue = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value.slice(0, 10);
        if (value instanceof Date && !Number.isNaN(value.getTime())) {
            return value.toISOString().split("T")[0];
        }
        return "";
    };

    const handleDateValue = (value, onChange) => {
        if (!value) return;
        const date = new Date(`${value}T00:00:00`);
        if (!Number.isNaN(date.getTime())) {
            onChange(date);
        }
    };






    return (
        <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-200 mb-6">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
                {/* <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Cliente
                    </label>
                    <Autocomplete
                        disablePortal
                        options={dataClientes}
                        fullWidth
                        loading={loadingCargarCliente}
                        value={clienteSelected || null}
                        getOptionLabel={(option) => option?.value || ''}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'input') {
                                handleNameClienteSearch(newInputValue);
                            }
                        }}
                        onChange={(event, value) => {
                            handleClienteSelected(value);
                        }}
                        loadingText={'Cargando...'}
                        noOptionsText={'No hay opciones'}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f1f5f9',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                    },
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loadingCargarCliente ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </div> */}

                <div className="col-span-1 lg:col-span-2">
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Desde (creación de la factura)
                    </label>
                    <input
                        type="date"
                        value={formatDateInputValue(fechaInicio)}
                        onChange={(e) => handleDateValue(e.target.value, handleFechaInicio)}
                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                    />
                </div>

                <div className="col-span-1 lg:col-span-2">
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Hasta (creación de la factura)
                    </label>
                    <input
                        type="date"
                        value={formatDateInputValue(fechaFin)}
                        onChange={(e) => handleDateValue(e.target.value, handleFechaFin)}
                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                    />
                </div>
            </div>

        </div>
    );
}
export default FitrosDobleCheckComponent;